import React, { useState, useEffect, useCallback } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';

const PaymentTermsSelect = ({
  value,
  onChange,
  required = false,
  placeholder = "Select payment terms...",
  disabled = false,
  className = '',
  includeAdvance = true
}) => {
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPaymentTerms = useCallback(async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${config.API_BASE_URL}/payment-terms`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      let terms = response.data;
      if (!includeAdvance) {
        terms = terms.filter(term => term.days > 0);
      }

      setPaymentTerms(terms);
      setError(null);
    } catch (error) {
      console.error('Error fetching payment terms:', error);
      setError('Failed to load payment terms');
    } finally {
      setLoading(false);
    }
  }, [includeAdvance]);

  useEffect(() => {
    fetchPaymentTerms();
  }, [fetchPaymentTerms]);

  if (loading) {
    return (
      <Form.Group className={className}>
        <Form.Label>Payment Terms {required && '*'}</Form.Label>
        <div className="d-flex align-items-center">
          <Spinner animation="border" size="sm" className="me-2" />
          <Form.Control
            as="select"
            disabled
            className="form-select"
          >
            <option>Loading...</option>
          </Form.Control>
        </div>
      </Form.Group>
    );
  }

  if (error) {
    return (
      <Form.Group className={className}>
        <Form.Label>Payment Terms {required && '*'}</Form.Label>
        <Form.Control
          as="select"
          disabled
          className="form-select"
        >
          <option>Error: {error}</option>
        </Form.Control>
      </Form.Group>
    );
  }

  return (
    <Form.Group className={className}>
      <Form.Label>Payment Terms {required && '*'}</Form.Label>
      <Form.Control
        as="select"
        value={paymentTerms.find(term => {
          if (value === 'Advance') {
            return term.days === 0;
          }
          return term.name === value;
        })?._id || ''}
        onChange={(e) => {
          const selectedTerm = paymentTerms.find(term => term._id === e.target.value);
          const termLabel = selectedTerm ?
            (selectedTerm.days === 0 ? 'Advance' : selectedTerm.name) : '';
          onChange && onChange(termLabel);
        }}
        disabled={disabled}
        required={required}
        className="form-select"
      >
        <option value="">{placeholder}</option>
        {paymentTerms.map(term => (
          <option key={term._id} value={term._id}>
            {/* {term.days === 0 ? 'Advance' : `${term.days} Days`}
            {term.description && ` - ${term.description}`} */}
            {term.name && `${term.name}`}
          </option>
        ))}
      </Form.Control>
      {/* <Form.Text className="text-muted">
        Select appropriate payment terms for this transaction
      </Form.Text> */}
    </Form.Group>
  );
};

export default PaymentTermsSelect;
